import React, { useState, useEffect } from "react";
import { Td, Tr } from "@lightspeed/cirrus-table";
import { Button } from "@lightspeed/flame/Button";
import { Input } from "@lightspeed/flame/Input";
import { useDispatch, useSelector } from "react-redux";
import * as databaseActions from "../../../redux/actions/databaseActions";

const Row = ({ item }) => {
  const dispatch = useDispatch();
  const ui = useSelector((state) => state.ui);
  const userState = useSelector((state) => state.userState);
  const database = useSelector((state) => state.database);
  const [edit, setEdit] = useState(false);
  const [changed, setChanged] = useState(false);
  const [inputBox1, setInputBox1] = useState("");
  const [inputBox2, setInputBox2] = useState("");
  const [inputBox3, setInputBox3] = useState("");
  const [inputBox4, setInputBox4] = useState("");
  const normalAccount = item.account_id === null ? "" : item.account_id;
  const normalAccountDescription = item.account_description === null ? "" : item.account_description;
  const normalID = item.over_short_id === null ? "" : item.over_short_id;
  const normalNAME = item.over_short_name === null ? "" : item.over_short_name;

  useEffect(() => {
    setInputBox1(normalAccount);
    setInputBox2(normalAccountDescription);
    setInputBox3(normalID);
    setInputBox4(normalNAME);
    if (normalAccount === "" && normalAccountDescription === "") {
      setEdit(true);
    } else {
      setEdit(false);
    }
  }, [normalAccount, normalAccountDescription]);
  useEffect(() => {
    if (normalAccount === inputBox1 && normalAccountDescription === inputBox2 && normalID === inputBox3 && normalNAME === inputBox4) {
      setChanged(false);
    } else {
      setChanged(true);
    }
  }, [inputBox1, inputBox2, inputBox3, inputBox4, normalAccount, normalAccountDescription, normalID, normalNAME]);

  /*
  PROMJENA
  */

  const handleUpdate = () => {
    if (database.currentCompany.type === "RETAIL") {
      dispatch(
        databaseActions.updateRetailPayment(
          userState.user.user_id,
          item.company_id,
          database.currentShop.shop_id,
          inputBox1,
          inputBox2,
          item.paymenttype_id,
          inputBox3,
          inputBox4,
          databaseActions.getShopPayments(
            database.currentCompany.id,
            userState.user.user_id,
            database.currentShop.shop_id
          )
        )
      );
    } 

    if (database.currentCompany.type === "RETAILX") {
      dispatch(
        databaseActions.updateRetailPaymentX(
          userState.user.user_id,
          item.company_id,
          database.currentShop.shop_id,
          inputBox1,
          inputBox2,
          item.paymenttype_id,
          databaseActions.getShopPaymentsX(
            database.currentCompany.id,
            userState.user.user_id,
            database.currentShop.shop_id
          )
        )
      );
    }
    
    if (database.currentCompany.type === "RESTOK") {
        if (database.currentCompany.direct) {
          dispatch(
            databaseActions.updateRestoPaymentsK(
              userState.user.user_id,
              item.company_id,
              item.paymenttype_id,
              inputBox1,
              inputBox2,
              0,
              databaseActions.getAreaPaymentsK(
                userState.user.user_id,
                database.currentCompany.id,
                0
              )
            )
          );
        } else {
          dispatch(
            databaseActions.updateRestoPaymentsK(
              userState.user.user_id,
              item.company_id,
              item.paymenttype_id,
              inputBox1,
              inputBox2,
              database.currentShop.area_id,
              databaseActions.getAreaPaymentsK(
                userState.user.user_id,
                database.currentCompany.id,
                database.currentShop.area_id
              )
            )
          );
        }
    } if (database.currentCompany.type === "RESTO") {
      if (database.currentCompany.direct) {
        dispatch(
          databaseActions.updateRestoPayments(
            userState.user.user_id,
            item.company_id,
            item.paymenttype_id,
            inputBox1,
            inputBox2,
            0,
            databaseActions.getAreaPayments(
              userState.user.user_id,
              database.currentCompany.id,
              0
            )
          )
        );
      } else {
        dispatch(
          databaseActions.updateRestoPayments(
            userState.user.user_id,
            item.company_id,
            item.paymenttype_id,
            inputBox1,
            inputBox2,
            database.currentShop.area_id,
            databaseActions.getAreaPayments(
              userState.user.user_id,
              database.currentCompany.id,
              database.currentShop.area_id
            )
          )
        );
      }
    }
    setEdit(false);
  };

  return (
    <Tr
      textAlign="right"
      className={`${ui.theme === "flame" ? "" : "dark-table-row"}`}
      onDoubleClick={() => {
        setInputBox1(normalAccount);
        setInputBox2(normalAccountDescription);
        setInputBox3(normalID);
        setInputBox4(normalNAME);
        setEdit(true);
      }}
    >
      <Td width="15%">{item.company_id}</Td>
      <Td width="15%">{item.paymenttype_id}</Td>
      <Td width="20%">{item.paymenttypeid_name}</Td>
      <Td width="20%">
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox1}
            <div className="flex" />
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox1}
                onChange={(e) => setInputBox1(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
            </div>
          </div>
        )}
      </Td>

      <Td width="20%">
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox2}
            <div className="flex" />
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox2}
                onChange={(e) => setInputBox2(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
            </div>
          </div>
        )}
      </Td>

      <Td width="20%">
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox3}
            <div className="flex" />
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox3}
                onChange={(e) => setInputBox3(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
            </div>
          </div>
        )}
      </Td>


      <Td width="20%">
        {!edit && (
          <div className="row-input-wrapper">
            {inputBox4}
            <div className="flex" />
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper">
            <div>
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={inputBox4}
                onChange={(e) => setInputBox4(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleUpdate();
                  }
                }}
              />
            </div>
          </div>
        )}
      </Td>


      <Td width="10%" textAlign="right">
        {!edit && (
          <div className="row-input-wrapper-end">
            <Button
              onClick={(_) => {
                setInputBox1(normalAccount);
                setInputBox2(normalAccountDescription);
                setInputBox3(normalID);
                setInputBox4(normalNAME);
                setEdit(true);
              }}
              size="small"
              fill="true"
            >
              Edit
            </Button>
          </div>
        )}

        {edit && (
          <div className="row-input-wrapper-end">
            {changed ? (
              <Button onClick={handleUpdate} size="small" fill="true">
                Update
              </Button>
            ) : inputBox1 === "" && inputBox2 === "" && inputBox3 === "" && inputBox4 === "" ? null : (
              <Button
                onClick={(_) => {
                  setInputBox1(normalAccount);
                  setInputBox2(normalAccountDescription);
                  setInputBox3(normalID);
                  setInputBox4(normalNAME);
                  setEdit(false);
                }}
                size="small"
                fill="true"
              >
                Cancel
              </Button>
            )}
          </div>
        )}
      </Td>
    </Tr>
  );
};

export default Row;
